<template>
  <div class="loader" v-if="loading">
    <orbit-spinner :animation-duration="1200" :size="55" :color="'#0d8285'" />
  </div>
  <div class="news-full-bg" v-else>
    <div class="view">
      <div class="view-header">
        <div class="view-title">
          <div class="types">{{ item.menu.name }}</div>
          <h1>{{ item.name }}</h1>
          <div class="journalist">
            <div class="float-right social-btn">
              <vue-goodshare-facebook
                has_icon
                button_design="gradient"
                title_social="Хуваалцах"
              ></vue-goodshare-facebook>
              <vue-goodshare-twitter
                has_icon
                button_design="gradient"
                title_social="Жиргэх"
              ></vue-goodshare-twitter>
            </div>
            <div class="avatar">
              <b-img :src="item.writer.full_image" :alt="item.writer.name" />
            </div>
            <div>{{ item.writer.name }}</div>
            <span
              ><fa-icon :icon="{ prefix: 'far', iconName: 'clock' }" />
              {{ item.sdate }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="view-img">
      <b-img :src="bigimg" :alt="item.name" fluid />
    </div>
    <div class="view">
      <div v-html="item.content" class="news-body"></div>
    </div>
    <div class="view-img">
      <div v-for="img in item.gallery" :key="'img-' + img.id">
        <b-img
          :src="'/images/gallery/' + img.image"
          :alt="img.name"
          class="mb-1 mt-3"
          fluid
        />
        <div class="text-muted">{{ img.name }}</div>
      </div>
    </div>
    <div class="view">
      <Comment />
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faClock } from "@fortawesome/free-regular-svg-icons";
import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter.vue";

import { getView } from "./../../api";
import { OrbitSpinner } from "epic-spinners";
import Comment from "./Comment";
library.add(faClock);
library.add(faFacebookF);
library.add(faTwitter);

Vue.component("fa-icon", FontAwesomeIcon);

export default {
  data() {
    return {
      item: {},
      loading: true
    };
  },
  components: {
    Comment,
    OrbitSpinner,
    VueGoodshareTwitter,
    VueGoodshareFacebook
  },
  methods: {
    reload() {
      this.loading = true;
      getView(this.$route.params.id).then(response => {
        if (response.data.status === "success") {
          this.loading = false;
          this.item = response.data.data;
        } // else console.log(response.data.message);
      });
    }
  },
  computed: {
    bigimg() {
      if (this.item.org_image == "") return this.item.thumb;
      else
        return (
          "http://news.zindaa.mn/images/news/origin/" + this.item.org_image
        );
    }
  },
  mounted() {
    // console.log("mounted");
    this.reload();
  },
  watch: {
    $route() {
      // console.log("updated");
      this.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../sass/boots/custom_bootstrap";
.news-full-bg {
  margin-bottom: 0;
  .view-img {
    display: block;
    text-align: center;
  }
}
.view {
  background-color: #fff;
  width: 700px;
  display: block;
  @media (max-width: 700px) {
    width: 100%;
  }
  margin: 0 auto;
  padding: 15px;
  .view-header {
    padding: 2em 0 1em 2em;

    .view-title {
      h1 {
        font-family: $slab;
        font-size: 2em;
        margin: 0;
        padding: 0.4em 2em 0.4em 0;
      }
      .types {
        color: $primary;
      }
      span {
        font-size: 0.9em;
        color: $gray-light;
      }
    }
    @media (max-width: 425px) {
      padding: 1em 0 0 1em;
      .view-title {
        h1 {
          font-size: 1.5em;
          padding: 0.4em 0.4em 0.8em 0;
        }
      }
    }
    .journalist {
      font-size: 14px;
      .avatar {
        height: 44px;
        width: 44px;
        margin-right: 10px;
        border-radius: 44px;
        overflow: hidden;
        float: left;
        img {
          width: 100%;
        }
      }
    }
  }

  .news-body {
    font-size: 14px !important;
    margin: 0 auto;
    line-height: 1.8em;
    padding: 1em;
    font-size: 1em;
    /deep/ iframe {
      max-width: 100%;
    }

    /deep/ span,
    p,
    div {
      font-family: $slab !important;
    }
    /deep/ blockquote {
      background-color: #f1f1f1;
      border-left: 2px solid $primary;
      padding: 15px;
      p {
        margin: 0;
        padding: 0;
      }
    }
    /deep/ ul {
      margin-left: 20px;
      li {
        list-style-type: square;
      }
    }
  }
}
/deep/ .button-social {
  i {
    color: #fff;
  }
  .title-social {
    color: white;
    font-size: 14px;
    text-transform: uppercase;
  }
  @media (max-width: 425px) {
    span {
      display: none;
    }
  }
}
</style>
